import { NavLink, Navigate, Route, Routes } from 'react-router-dom'
import { useMe } from '../api/hooks'
import { NotPermitted } from '../components/NotPermitted'
import { ApiKeysTab } from '../settings/ApiKeysTab'
import { ClientProjectsTab } from '../settings/ClientProjectsTab'
import { LocalesTab } from '../settings/LocalesTab'
import { PlatformsTab } from '../settings/PlatformsTab'
import { ProvidersTab } from '../settings/ProvidersTab'
import { UsersTab } from '../settings/UsersTab'

const TABS = [
  { to: 'users', label: 'Users' },
  { to: 'api-keys', label: 'API keys' },
  { to: 'ai-providers', label: 'AI providers' },
  { to: 'locales', label: 'Locales' },
  { to: 'platforms', label: 'Platforms' },
  { to: 'client-projects', label: 'Client projects' },
]

/** Admin-only. Reachable by a direct URL hit too — gated here, not just by
 *  hiding the nav link, so an editor gets a clean "not permitted" state
 *  instead of a blank page, an error boundary, or (worse) the real content. */
export function Settings() {
  const me = useMe()

  if (me.isLoading) {
    return <p className="p-4 text-xs text-ink-600">Loading…</p>
  }
  if (me.data?.role !== 'admin') {
    return <NotPermitted />
  }

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div className="border-b border-ink-200 bg-white px-3 pt-2">
        <h1 className="text-sm font-semibold text-ink-900">Settings</h1>
        <nav className="mt-2 flex gap-1 text-xs" aria-label="Settings sections">
          {TABS.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) =>
                `rounded-t px-2.5 py-1.5 ${isActive ? 'border-b-2 border-blue-600 font-semibold text-ink-900' : 'text-ink-600 hover:bg-ink-50'}`
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto bg-ink-50 p-4">
        <Routes>
          <Route index element={<Navigate to="users" replace />} />
          <Route path="users" element={<UsersTab />} />
          <Route path="api-keys" element={<ApiKeysTab />} />
          <Route path="ai-providers" element={<ProvidersTab />} />
          <Route path="locales" element={<LocalesTab />} />
          <Route path="platforms" element={<PlatformsTab />} />
          <Route path="client-projects" element={<ClientProjectsTab />} />
          <Route path="*" element={<Navigate to="users" replace />} />
        </Routes>
      </div>
    </div>
  )
}
